import { NEWBUILDING_BUILDER_CALL_REASONS } from 'shared/selectors/abExperiments/selectBuilderCallReasonsExperimentActive';

import { CALLTRACKING_WARNING } from '../../experiments/calltrackingWarning';
import { NEWBUILDING_OFFER_REDESIGN_EXPERIMENT, NEWBUILDING_WINNER_EXPERIMENT } from '../../selectors/abExperiments';
import { COMMERCIAL_TC_BC_BLOCK_EXPERIMENT } from '../../selectors/abExperiments/commercialTCBCBlockExperiment';
import { COMMERCIAL_UNIQUE_TO_CIAN_EXPERIMENT_V2 } from '../../selectors/abExperiments/isCommercialUniqueToCianExperimentEnabledSelector';
import { HOUSE_CARD_URL_EXPERIMENT } from '../../utils/experiments/houseCardUrl';
export const AUD_DESKTOP_ACTI127_OFFER_PAGE_CHAT_SUGGESTIONS = 'aud_desktop_acti127_offer_page_chat_suggestions';

export const EXPERIMENTS: string[] = [
  HOUSE_CARD_URL_EXPERIMENT,
  CALLTRACKING_WARNING,
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-125416, будет удалён в задаче CD-125446
   */
  COMMERCIAL_TC_BC_BLOCK_EXPERIMENT,
  NEWBUILDING_WINNER_EXPERIMENT,
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-153172, будет удалён в задаче CD-153173
   */
  COMMERCIAL_UNIQUE_TO_CIAN_EXPERIMENT_V2,
  NEWBUILDING_OFFER_REDESIGN_EXPERIMENT,
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-164218, будет удалён в задаче CD-164236
   */
  NEWBUILDING_BUILDER_CALL_REASONS,
  AUD_DESKTOP_ACTI127_OFFER_PAGE_CHAT_SUGGESTIONS,
];
